export const BASE_URL = '/api/v1'

export default { BASE_URL }
